import React, {useEffect, useState} from 'react';

import {compose} from 'redux';
import TopoListItem from "./TopoListItem";
import {changeBottomNavigation, changeTitle, setSearchGuidebookQuery, showMenuNavBar} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {useUser} from "../../hooks/useUser";
import {useAuth} from "../../context/auth-context";
import {flattenSearchResult, isGuidebookUnlocked} from "../../utils/helpers";
import useGuidebooks from "../../hooks/useGuidebooks";
import {Alert, Button, Grid} from "@mui/material";
import SearchComponent from "./SearchComponent/SearchComponent";
import Constants from "../../config/constants";
import FillScreenLayout from "../FillScreenLayout";

const TopoListComponent = ({t, i18n, query: propQuery, setSearchGuidebookQuery}) => {
    const auth = useAuth();
    const [query, setQuery] = useState(propQuery);
    const {
        status,
        data,
        error,
        hasNextPage,
        fetchNextPage,
        isFetching }  = useGuidebooks(query, i18n.language);
    const { status: statusUser, data: user, error: errorUser } = useUser(auth?.user?.email, i18n.language);
    const facetDistribution = [
        {name: 'type', display: {type: 'multiple', grid: 12}},
        {name: 'regionIds', display: {type: 'tree'}},
    ];

    let isEmptyResult = true;
    let flatItems = [];
    let facetsData = [];
    if (status === 'success' && Array.isArray(data.pages[0].hits)) {
        isEmptyResult = data.pages[0].hits?.length === 0;
        facetsData = data.pages[0].facets;
        flatItems = flattenSearchResult(data);

        if (query.order === 'my_guidebooks') {
            flatItems = flatItems.filter((g) => isGuidebookUnlocked(user, g));
        }
    }

    const handleClearChoices = () => {
        updateQuery({...query, choices: []});
    };

    const updateQuery = (query) => {
        setSearchGuidebookQuery(query);
        setQuery(query);
    }
    const orderList = [
        {value: 'position_asc', label: t("SearchComponent.display.position_asc")},
        {value: 'createdAt_desc', label: t("SearchComponent.display.createdAt_desc")},
    ];

    const allowMyGuidebookOrder = auth.isAuthenticated && (user?.validations.length > 0 || user?.guidebooks.length > 0);
    if (allowMyGuidebookOrder) {
        orderList.push({value: 'my_guidebooks', label: t("SearchComponent.display.my_guidebooks")});
    }

    const loadMore = () => {
        if (hasNextPage) {
            fetchNextPage({ pageParam: data.pageParams.length });
        }
    };

    return (
        <FillScreenLayout>
            <div className={"borderBottom"}>
                <SearchComponent
                    facetDistribution={facetDistribution}
                    updateQuery={updateQuery}
                    query={query}
                    facets={facetsData}
                    orderLabel={t("SearchComponent.display.sort")}
                    orderList={orderList}
                    hasTextualSearch={false}
                />
            </div>

            {status === "pending" &&
            <div className={"loadingWrapper"}>
                <div id="loading"/>
            </div>}
            {!isEmptyResult && <div className={"flexGrowAuto"}>
                <Grid container direction="row" justifyContent="space-around"  alignItems="flex-start" >
                    <Grid item xs={12} style={{marginLeft: '4px', marginRight: '4px',}}>
                        <Grid container direction="row" spacing={1}>
                            {status === "success" && flatItems.map(function (object, index) {
                                return (<React.Fragment  key={auth.getUniqUserKey() + '-' + object.id}>
                                        <Grid item className="mt-3 topoList" xs={6} md={4} lg={3}>
                                            <TopoListItem topo={object}
                                                          unlocked={isGuidebookUnlocked(user, object)}
                                            />
                                        </Grid>
                                    {/*{index === flatItems.length-1 && <InfiniteListLastItem hasNextPage={hasNextPage}*/}
                                    {/*                                                       loadMore={loadMore}*/}
                                    {/*                                                       height={100}/>}*/}
                                </React.Fragment>

                                );
                            })}
                        </Grid>
                    </Grid>
                </Grid>

            </div>}

            {isEmptyResult && <div className={"flexGrowAuto"}>
                <Alert severity="info" style={{marginTop: "15px", marginBottom: "15px"}}>
                    {t("TopoListComponent.alert.emptySearch")}
                </Alert>
                <div className="text-center">
                    <Button variant="contained" color="primary" onClick={handleClearChoices}>{t("TopoListComponent.button.clearAll")}</Button>
                </div>
            </div> }
        </FillScreenLayout>
    );
};

const mapStateToProps = (state) => {
    let defaultQuery = {
        q: '',
        facets: [],
        screenChoices: [],
        choices: [],
        limit: Constants.search.guidebook.limit,
        language: null,
        version: 2,
        order: 'position_asc',
    };

    let props = {};
    if (typeof state.search.guidebookQuery === "undefined"
        || state.search.guidebookQuery?.version !== defaultQuery.version) {
        props = {...props, query: defaultQuery}
    } else {
        props = {...props, query: state.search.guidebookQuery}
    }

    return props;
};

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
        setSearchGuidebookQuery: (query) => {
            dispatch(setSearchGuidebookQuery(query))
        }
    }
}

export default compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(TopoListComponent)
